import React, { useState, useEffect, useMemo } from 'react';
import { Box,Typography, Grid } from '@mui/material';
import { firebaseHelper, useDesignFirm } from 'ui';
import { subscriptionURL } from '../libs/firebase';
import { DesignFirmType,SubscriptionData } from 'ts-interfaces';
import { myStyles as styles } from '../libs/util';
import Invite from './Invite';
import TeamMembersComponent from './TeamMembersComponent';
import { TeamsInterface } from 'ts-interfaces';
import { collection, onSnapshot, query, orderBy, where } from 'firebase/firestore';


export const Teams = ({designFirmID}) => {
  const [teamMembers, setTeamMembers] = useState<TeamsInterface[]>([]);
  const [pendingInvites, setPendingInvites] = useState<TeamsInterface[]>([]);
  const [teamsLoading, setTeamsLoading] = useState(true);

  const currentSeats = useMemo(() => {
      return teamMembers.filter((member) => member.role != 'admin'  && member.status === 'active').length 
      + pendingInvites.filter((member) => member.role != 'admin' && member.status !== 'invited_inactive').length;
  },[teamMembers, pendingInvites]);

  const hookResult = useDesignFirm(firebaseHelper.db, designFirmID, subscriptionURL);
  const { firm, subscription, loading, error } = hookResult || {};
	
  useEffect(() => {
    if (!firm?.id) {
        setTeamMembers([]); setPendingInvites([]); setTeamsLoading(false);
        return;
    }
    setTeamsLoading(true);
    // Query for all team members for this design firm
    const teamsRef = collection(firebaseHelper.db, 'teams');
    const q = query(
      teamsRef,
      where('designFirmID', '==', firm.id),
      orderBy('updatedAt', 'desc')
    );  
    const unsubscribe = onSnapshot(q, (snapshot) => {
      const activeMembers: TeamsInterface[] = [];
      const invitedMembers: TeamsInterface[] = [];      
      snapshot.forEach((doc) => {
        const data = { id: doc.id, ...doc.data() } as TeamsInterface;        
        if (data.status === 'active' || data.status === 'inactive') {
          activeMembers.push(data);
        } else if (data.status === 'invited' || data.status === 'invited_inactive') {
          invitedMembers.push(data);
        }
      });      
      setTeamMembers(activeMembers); setPendingInvites(invitedMembers); setTeamsLoading(false);
    }, (error) => {
      console.error('Error fetching team data:', error);
      setTeamsLoading(false);
    });
    // Clean up listener
    return () => unsubscribe();
  }, [firm?.id]);
  

  return (
    <Box sx={styles.container}>
      <Typography variant="h4" component="h1" sx={{ fontWeight: 'bold', mb: 1 }}>
        Team Management
      </Typography>
      <Typography variant="body1" sx={{ color: 'text.secondary', mb: 4 }}>
        Invite team members to your design firm and manage their roles and permissions.
      </Typography>

      <Grid container spacing={3} sx={{ mb: 5 }}>
        <Grid item xs={12} md={12}>
            <Invite designFirmDomain={firm?.domain} designFirmId={firm?.id} currentSeatsUsed={ currentSeats } totalSeatsAvailable={firm?.seats} />
        </Grid>
        <Grid item xs={12} md={12}>
            <TeamMembersComponent designFirmID={firm?.id} teamMembers={teamMembers} teamsLoading={teamsLoading} pendingInvites={pendingInvites} currentSeatsUsed={currentSeats} totalSeatsAvailable={firm?.seats} />
        </Grid>

      </Grid>
    </Box>
  )
}